import React, { useCallback } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { getCartDelPrice, getCartLowerPrice, getDelPrice, getLowerPrice, getProductUrl, isPromotion, unitPrice } from '../../../../../../utils/product'
import { Iconfont } from '../../../../../components/icon/iconfont'
import { FormattedMessage } from 'react-intl'
import { useState } from 'react'
import _ from 'lodash'
import { withCartIcon } from '../../../../listing/components/cart/cart-icon'
import { BigButton } from '../../../../../components/button'
import { useEffect } from 'react'
import { SensorsTrack } from '../../../../../utils/sensor'
import { useMemo } from 'react'
import { IMAGE_GEEKO_LTD } from '../../../../../../constants'
import CountDown from '../../../../../components/count-down'
import { useDispatch, useSelector } from 'react-redux'
import { action_fetch_cart } from '../../../../../../store/actions/pages/cart'


const SizeColor = withCartIcon(props => {
    useStyles(classes)
    const { size, color, onCart, disabled } = props

    const cartHandle = e => {
        SensorsTrack('CartAction', {action: 'ClickColor'})
        if(disabled) return
        onCart(e)
    }

    const labels = [color, size]?.filter(s => !!s)

    return <span className={`${classes.SizeColor} ${disabled? classes.Disabled: ''}`} onClick={cartHandle}>
        <span className={classes.Text}>{labels?.join('/')}</span>
        <Iconfont className={classes.Icon}>&#xe692;</Iconfont>
    </span>
})

const Quantity = props => {
    useStyles(classes)
    const { quantity, itemDeleteHandle, itemChangeQtyHandle, disabled, canRemove } = props
    const [qty, setQty] = useState(quantity)

    const debouncedHandle = useCallback(_.debounce(itemChangeQtyHandle, 400), [])

    const minusHandle = () => {
        SensorsTrack('CartAction', {action: 'ClickDecreaseQty'})
        if(disabled) return
        if (qty > 1) {
            const q = qty - 1
            setQty(q)
            debouncedHandle(q)
        } else if(canRemove){
            itemDeleteHandle()
        }
    }

    const addHandle =() => {

        SensorsTrack('CartAction', {action: 'ClickIncreaseQty'})

        if(disabled) return
        const q = qty + 1
        setQty(q)
        debouncedHandle(q)
    }

    useEffect(() => {
        setQty(quantity)
    }, [quantity])

    const changeHandle = e => {
        const value = e.target.value
        if(value){
            setQty(value)
            debouncedHandle(value)
        }
    }


    return <span className={`${classes.Quantity} ${disabled? classes.Disabled: ''}`}>
        <Iconfont onClick={minusHandle} className={classes.Icon}>&#xe731;</Iconfont>
        <input className={classes.Number} value={qty} type="number" onChange={changeHandle}/>
        <Iconfont className={classes.Icon} onClick={addHandle}>&#xe733;</Iconfont>
    </span>
}

const ReductionMessage = props =>{
    const { product } = props;

    useEffect(() =>{
        if(window.GeekoSensors){
			window.GeekoSensors.Track('PriceReduce', {
				product_id: product.productId,
				price_range: Number(product?.usdReductionPrice?.amount),
			})
		}
    }, []);

    return <div className={classes.AddonMsg}>
        <span dangerouslySetInnerHTML={{
            __html: `<span style="display:flex;">
                <img src="${IMAGE_GEEKO_LTD}/chicme/20230504031858436777.png"/>
                ${product.reductionMsg}
            </span>`
        }}></span>
    </div>
}
const SoldMessage = props =>{
    const { product } = props;

    return <div className={classes.SoldMessage}>
        <span dangerouslySetInnerHTML={{
            __html: `<span style="display:flex;">
                <span class="iconfont" style="font-size: 10px">&#xE715;</span>
                <span style="margin-left: 0.2em">${product.soldMsg}</span>
            </span>`
        }}></span>
        {product.addedToCartMsg&&<span dangerouslySetInnerHTML={{
            __html: `<span style="display:flex;">
                <span class="iconfont" style="font-size: 10px">&#xE685;</span>
                <span style="margin-left: 0.2em">${product.addedToCartMsg}</span>
            </span>`
        }}></span>}
    </div>
}

const LimitedDiscount = props =>{
    const { offset } = props;
    const [show, setShow] = useState(true);
    const dispatch = useDispatch();

    const onCallBackHandle = useCallback(() =>{
        setShow(false);
        dispatch(action_fetch_cart())
    }, []);

    return <React.Fragment>
        {
            show &&
            <div className={classes.LimitDiscountBorder}>
                <div className={classes.LimitDiscount}>
                    <span><FormattedMessage id="limited_discount" defaultMessage="Limited Discount" />: </span>

                    <CountDown 
                        offset={offset} 
                        numberClass={classes.NumberClass} 
                        labelClass={classes.NumberClass} 
                        callback={onCallBackHandle} 
                        showHour 
                        showLabel
                    />
                </div>
            </div>
        }
    </React.Fragment>
    
}

export default props => {
    useStyles(classes)
    const { item, soldout, itemDeleteHandle, itemChangeQtyHandle, addToWishList, itemChangeItemHandle, isGift, isAddOn, isCart, editing, addOnMsg } = props
    const hasDelPrice = Number(item.realPrice?.amount) - Number(item.itemPrice?.amount) < 0
    const onlyLeft = item.quantity > item.inventory && !item.isAutoInventory && !item.isDomesticDelivery

    const pageCart = useSelector(state => state.pageCart);
    const { cart } = pageCart;

    const [lowerPrice, delPrice] = [
		getCartLowerPrice(item),
		getCartDelPrice(item),
	]

    const clickHandle = e => {
        e.preventDefault()
        window.location.href = productUrl
        return
    }

    const productUrl = useMemo(() => {
		let url = getProductUrl(item.productId, item.productName, item.color)
		if(isGift){
			if(url?.indexOf("?") == -1){
				url += '?product_type=gift'
			} else {
				url += '&product_type=gift'
			}
		} else if(isAddOn){
            if(url?.indexOf("?") == -1){
				url += '?product_type=addOn'
			} else {
				url += '&product_type=addOn'
			}
        }
		return url
	}, [item, isGift, isAddOn])

    let off = 0
	if (hasDelPrice) {
		off = Math.round((Number(delPrice?.amount) - Number(lowerPrice?.amount)) * 100 / Number(delPrice?.amount))
	}

    return <div className={classes.Item}>
        <div className={classes.Image} onClick={clickHandle}>
            <img src={item.imageUrl} />
            {
                soldout && <div className={classes.SoldMask}>
                    <FormattedMessage id="sold_out" defaultMessage="Sold Out" />
                </div>
            }

            {
                off > 0 && !isGift && <span className={classes.OffTip}>{`-${off}%`}</span>
            }
        </div>
        <div className={classes.Information}>
            <div>
                <a className={classes.Name} href={getProductUrl(item.productId, item.productName)}>
                    {item.isPreOrder && <span className={classes.PreOrderFlag}>Pre order</span>}{item.productName}
                </a>
                <div className={classes.PAL}>
                    <span className={classes.Prices}>
                        <span className={`${hasDelPrice || isGift ? classes.Lower : classes.Normal}`}>
                            {
                                unitPrice(lowerPrice)
                            }
                        </span>

                        {
                            hasDelPrice && <del className={classes.Del}>
                                {
                                    unitPrice(delPrice)
                                }
                            </del>
                        }
                    </span>
                    {
                        !isAddOn && !isGift && !editing && <Iconfont onClick={e => addToWishList(item.id, item.productId)} className={classes.MoveToLike}>&#xe7b5;</Iconfont>
                    }
                </div>
                {
                    isAddOn && addOnMsg &&
                    <div className={classes.AddonMsg}>
                        <span dangerouslySetInnerHTML={{__html: addOnMsg}}></span>
                    </div>
                }

                {
                    !soldout && !isAddOn && item?.reductionMsg && <ReductionMessage product={item} />
                }
                {
                    !soldout && !isAddOn && !item?.reductionMsg&&item.soldMsg && <SoldMessage product={item} />
                }

                {
                    item?.promotionType == "10" && (item?.promotionEndTime - cart.serverTime > 1000) && <LimitedDiscount offset={item.promotionEndTime - cart.serverTime} />
                }
            </div>

            <div>
                {
                    onlyLeft && !soldout && <div className={classes.SubTools}>
                        <BigButton onClick={e => itemChangeQtyHandle(item, item.inventory)} className={classes.OnlyLeft}><FormattedMessage id="only_left" defaultMessage="Only {count} Left" values={{count: item.inventory}}/></BigButton>
                    </div>
                }
                <div className={classes.Tools}>
                    {
                        soldout ? <span className={classes.FindSimillar} onClick={e => {
                            window.location.href = `/similar/${item.productId}.html`
                        }}>
                            <span>
                                <FormattedMessage id="find_simillar" defaultMessage="Find similar" />
                            </span>
                        </span> : <>
                            <SizeColor disabled={editing} isGift={isGift && !isAddOn} isAddOn={isAddOn} size={item.size} color={item.color} productId={item.productId} variantId={item.variantId} addToCartApi={itemChangeItemHandle ? (data => itemChangeItemHandle(item, data)) : undefined} />
                            {
                                ((isGift || isAddOn) && !editing) ?
                                <React.Fragment>
                                    {
                                        item?.canRemove &&
                                        <Iconfont onClick={() => itemDeleteHandle(item)} className={classes.IconDel}>&#xe777;</Iconfont>
                                    }
                                </React.Fragment>:
                                <Quantity disabled={editing} canRemove={item?.canRemove} itemChangeQtyHandle={qty => itemChangeQtyHandle(item, qty)} itemDeleteHandle={() => itemDeleteHandle(item)} quantity={item.quantity} />
                            }
                        </>
                    }
                </div>
            </div>


        </div>
    </div>
}